import AppMessage from 'components/app-message/app-message';

export default AppMessage;
